import React from 'react';
import cn from 'classnames';
import { Image, Link } from '@landing/ui';

import * as styles from './Slide.module.scss';

export default function Slide({ name, image, country, items, instagram, theme }) {
  return (
    <article>
      <div className={cn(styles.content, theme && styles[theme])}>
        <div className={styles.nameMobile}>{name}</div>
        {country && <div className={styles.countryMobile}>{country}</div>}
        <Image className={styles.picture} classImage={styles.img} src={image} alt={name} />
        <div className={styles.textWrapper}>
          <h3 className={styles.name}>{name}</h3>
          <p className={styles.country}>{country}</p>
          <div className={styles.paragraphs}>
            {items.map(text => (
              <p key={text} className={styles.text}>
                {text}
              </p>
            ))}
            {instagram && (
              <p className={styles.text}>
                {instagram.label}
                <Link href={instagram.link}>{instagram.nickname}</Link>
              </p>
            )}
          </div>
        </div>
      </div>
    </article>
  );
}
